/*
export const someAction = (state) => {}
 */

export var setUserData = function setUserData(state, data) {
  state.commit('SET_USERDATA', data);
};
export var setUserLastRequest = function setUserLastRequest(state, data) {
  state.commit('SET_USERLASTREQUEST', data);
};
export var clearUserData = function clearUserData(state, data) {
  state.commit('CLEAR_USERDATA', data);
};